import React from "react";
import Main from "./components/Main";

var QuotesComponent = function QuotesComponent(_a) {
  var styles = _a.styles,
      env = _a.env,
      allowScroll = _a.allowScroll,
      isDemo = _a.isDemo,
      reset = _a.reset,
      applicationSubmissionId = _a.applicationSubmissionId,
      hideChat = _a.hideChat,
      coverdashBackButton = _a.coverdashBackButton,
      license = _a.license,
      autoResize = _a.autoResize,
      source = _a.source,
      prefilled = _a.prefilled,
      onApplicationCreated = _a.onApplicationCreated,
      onChangeBusiness = _a.onChangeBusiness,
      onApplicationSubmitted = _a.onApplicationSubmitted,
      onBoundPolicy = _a.onBoundPolicy,
      fakeQuote = _a.fakeQuote,
      hybrid = _a.hybrid;
  return React.createElement(React.Fragment, null, React.createElement(Main, {
    styles: styles,
    env: env,
    allowScroll: allowScroll,
    isDemo: isDemo,
    reset: reset,
    applicationSubmissionId: applicationSubmissionId,
    coverdashBackButton: coverdashBackButton,
    hideChat: hideChat,
    license: license,
    autoResize: autoResize,
    source: source,
    prefilled: prefilled,
    onApplicationCreated: onApplicationCreated,
    onChangeBusiness: onChangeBusiness,
    onApplicationSubmitted: onApplicationSubmitted,
    onBoundPolicy: onBoundPolicy,
    fakeQuote: fakeQuote,
    hybrid: hybrid
  }));
};

export default QuotesComponent;